const storeName = 'display-advert'

export const advert = {
    namespaced: true,
    state: {
        overviewSearch: localStorage.getItem(storeName + '-overview'),
    },
    mutations: {
        storeAdvertOverviewSearch(state, search) {
            state.overviewSearch = search;
            localStorage.setItem(storeName + '-overview', search ? search : '');
        }
    }
}